import { useTitle } from "@/hooks/use-title.hook.ts";
import { SurveyEditSidebar } from "@/pages/talent/surveys/edit/components/SurveyEditSidebar.tsx";
import { SurveyEditDetailsPage } from "@/pages/talent/surveys/edit/pages/SurveyEditDetailsPage.tsx";
import { SurveyEditFinalPage } from "@/pages/talent/surveys/edit/pages/SurveyEditFinalPage.tsx";
import { SurveyEditLaunchPage } from "@/pages/talent/surveys/edit/pages/SurveyEditLaunchPage.tsx";
import { SurveyEditNotificationsPage } from "@/pages/talent/surveys/edit/pages/SurveyEditNotificationsPage.tsx";
import { SurveyEditQuestionsPage } from "@/pages/talent/surveys/edit/pages/SurveyEditQuestionsPage.tsx";
import { SurveyEditPageStep } from "@/pages/talent/surveys/edit/survey-edit.ts";
import { useSurveySetup } from "@/queries/surveys/use-surveys.query.ts";
import { Button, FullScreenPage, Skeleton } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { SurveyEditTitleSlot } from "@/pages/talent/surveys/edit/pages/SurveyEditTitleSlot.tsx";

export const SurveyEditPage = () => {
  const { id, step } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: survey } = useSurveySetup(id ? parseInt(id) : undefined, !!id);

  useTitle(survey?.title, t("surveys:survey"));

  const currentStep = useMemo(() => {
    if (step) {
      return step as SurveyEditPageStep;
    }
    return SurveyEditPageStep.details;
  }, [step]);

  if (survey) {
    if (currentStep == SurveyEditPageStep.details) {
      return <SurveyEditDetailsPage survey={survey} />;
    } else if (currentStep == SurveyEditPageStep.questions) {
      return <SurveyEditQuestionsPage survey={survey} />;
    } else if (currentStep == SurveyEditPageStep.launch) {
      return <SurveyEditLaunchPage survey={survey} />;
    } else if (currentStep == SurveyEditPageStep.notifications) {
      return <SurveyEditNotificationsPage survey={survey} />;
    } else if (currentStep == SurveyEditPageStep.final) {
      return <SurveyEditFinalPage survey={survey} />;
    }
  }

  return (
    <FullScreenPage
      backSlot={
        <Button
          variant={"secondary"}
          size={"lg"}
          onClick={() => {
            navigate("/surveys");
          }}
        >
          {t("common:exit")}
        </Button>
      }
      titleSlot={<SurveyEditTitleSlot step={SurveyEditPageStep.details} survey={survey} />}
      isCenterVertical={false}
      sidebarSlot={<SurveyEditSidebar step={SurveyEditPageStep.details} />}
    >
      <Skeleton className={"w-full h-10"} />
    </FullScreenPage>
  );
};
